export default "__VITE_ASSET__35abeeb7__"